import type { SlotAssignmentFilter } from "@/types/employeeServices";

/* Placeholders — the migrated `-1` service, the pet form's `0` species — are not ids. */
const knownId = (id: number | null | undefined): number | undefined =>
  typeof id === "number" && Number.isInteger(id) && id > 0 ? id : undefined;

/**
 * The service and species a slot search should be narrowed to, so it only
 * offers employees the backend will accept when the appointment is created.
 *
 * Whatever is not known yet is left out, which searches as before. A search
 * pinned to one employee is never narrowed: the pages already offer only the
 * services that employee performs, and one with nothing assigned — still
 * bookable by hand — would otherwise find none of their own slots.
 * `EmployeeSlotsService` applies this to every search it sends; callers that
 * key a cache on the filter pass `employeeId` so the key matches.
 */
export const toSlotAssignmentFilter = (
  serviceId: number | null | undefined,
  speciesId: number | null | undefined,
  employeeId?: number | string | null,
): SlotAssignmentFilter => {
  const filter: SlotAssignmentFilter = {};
  if (knownId(Number(employeeId)) !== undefined) return filter;
  const service = knownId(serviceId);
  const species = knownId(speciesId);
  if (service !== undefined) filter.serviceId = service;
  if (species !== undefined) filter.speciesId = species;

  return filter;
};
